import { createPortal } from 'react-dom'
import { useTheme } from 'styled-components'
import { useEventListener } from 'usehooks-ts'
import { useModal } from '@velasca/hooks/use-modal'
import { CloseIcon } from '@velasca/icons/close'
import { IconButton } from '../IconButton/IconButton'
import { CloseButton, ModalBackground, VideoPlayer } from './VideoModal.styles'
import type { VideoModalProps } from './VideoModal.types'

const resetFocusToOuterDocument = () => {
  if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur()
  }
}

const fullscreenchanged = () => {
  if (!document.fullscreenElement) {
    resetFocusToOuterDocument()
  }
}

export const VideoModal = ({
  children,
  setIsModalOpen,
}: VideoModalProps): JSX.Element => {
  const theme = useTheme()
  const { ref: modalRef } = useModal({
    close: () => {
      setIsModalOpen(false)
    },
  })

  useEventListener('fullscreenchange', fullscreenchanged, modalRef)

  return createPortal(
    <ModalBackground>
      <CloseButton>
        <IconButton
          iconSize="2.5rem"
          color={theme.colors.text.secondary}
          onClick={() => {
            setIsModalOpen(false)
          }}
        >
          <CloseIcon />
        </IconButton>
      </CloseButton>
      <VideoPlayer ref={modalRef}>{children}</VideoPlayer>
    </ModalBackground>,
    document.body,
  )
}
